import { render, staticRenderFns } from "./el-file.vue?vue&type=template&id=4e0dccc6&scoped=true"
import script from "./el-file.vue?vue&type=script&lang=js"
export * from "./el-file.vue?vue&type=script&lang=js"
import style0 from "./el-file.vue?vue&type=style&index=0&id=4e0dccc6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e0dccc6",
  null
  
)

export default component.exports